'use client'

export default function ListLayout({
  sidebar = null,
  children,
  className = '',
  contentClassName = 'flex-1',
  withSidebarClassName = 'flex flex-col gap-x-40 pt-20 d:flex-row d:items-start',
  withoutSidebarClassName = 'flex flex-col gap-32 pt-20',
}) {
  const withSidebar = Boolean(sidebar)
  const layoutClassName = withSidebar ? withSidebarClassName : withoutSidebarClassName

  return (
    <div className={[layoutClassName, className].filter(Boolean).join(' ')}>
      {withSidebar ? sidebar : null}
      <div className={contentClassName}>{children}</div>
    </div>
  )
}
